import { gql } from '@grandvisionhq/graphql';
import PersonalDetailsFragment from '../fragments/personal-details.js';

var GET_PERSONAL_DETAILS = gql`
  query getPersonalDetails {
    me {
      id
      personalDetails {
        ...PersonalDetailsFragment
      }
    }
  }
  ${PersonalDetailsFragment}
`;

export { GET_PERSONAL_DETAILS as default };
//# sourceMappingURL=get-personal-details.js.map
